import React from "react";
import DataTable from "../../../Components/Table";

const SKELETON_COLUMNS = [
  { header: "Transaction", accessor: "transaction" },
  { header: "Description", accessor: "description" },
  { header: "Amount", accessor: "amount" },
  { header: "Payment Date", accessor: "paymentDate" },
  { header: "Payment Type", accessor: "paymentType" },
];

export default function BillTransactionHistorySkeleton() {
  return (
    <div className="bills-page__history-panel">
      <div className="bills-page__section-header">
        <div className="skeleton-line skeleton-line--headline" />
        <div className="skeleton-line skeleton-line--short" />
      </div>

      <div className="bills-page__history-toolbar row g-3 align-items-center">
        <div className="col-12 col-xl">
          <div className="bills-page__search-skeleton">
            <div className="skeleton-icon" />
            <div className="skeleton-line skeleton-line--input" />
          </div>
        </div>
        <div className="col-12 col-xl-auto">
          <div className="bills-page__history-date-skeleton">
            <div className="skeleton-line skeleton-line--input" />
          </div>
        </div>
      </div>

      <div className="bills-page__history-table-shell card">
        <DataTable columns={SKELETON_COLUMNS} data={[]} loading={true} />
      </div>
    </div>
  );
}
